import * as driver from './driver';
import * as form from './form';
import * as profile from './profile';
import * as series from './series';
import * as track from './track';
import * as ui from './ui';
import * as validation from './validation';

export default {
  driver,
  form,
  profile,
  series,
  track,
  ui,
  validation,
};
